// extracted by mini-css-extract-plugin
export default {"container":"CategoryTab_container__5abrK","popupBody":"CategoryTab_popupBody__dcM9i"};